import { Box, Stack, Typography } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { KEY_MOMENTS } from './resultsMockData'

/** Clickable list of key timeline moments with emotion swatch + delta arrow. */
export default function KeyMoments() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Stack spacing={1}>
      {KEY_MOMENTS.map((m, i) => {
        const color = theme.affexy.emotion[m.emotion]
        return (
          <Box
            key={i}
            sx={{
              p: 1.5,
              borderRadius: '12px',
              bgcolor: m.current ? alpha(c.coral, 0.05) : c.gray50,
              border: `1px solid ${m.current ? alpha(c.coral, 0.25) : c.ink08}`,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
              cursor: 'pointer',
            }}
          >
            <Typography
              sx={{ fontWeight: 700, fontSize: 13, color: c.ink, fontVariantNumeric: 'tabular-nums', flex: '0 0 36px', pt: 0.25 }}
            >
              {m.t}
            </Typography>
            <Box sx={{ width: 22, height: 22, borderRadius: '6px', bgcolor: alpha(color, 0.18), position: 'relative', flex: '0 0 22px', mt: '1px' }}>
              <Box sx={{ position: 'absolute', inset: '4px', borderRadius: '3px', bgcolor: color }} />
            </Box>
            <Stack spacing={0.25} sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 700, fontSize: 13, color: c.ink, lineHeight: 1.3 }}>
                {t(`keyMoments.${m.textKey}`)}
              </Typography>
              <Typography sx={{ fontSize: 11.5, color: c.ink56 }}>{t(`keyMoments.${m.subKey}`)}</Typography>
            </Stack>
            <Box component="span" sx={{ color: m.delta === 'up' ? c.success : c.danger }}>
              {m.delta === 'up' ? '▲' : '▼'}
            </Box>
          </Box>
        )
      })}
    </Stack>
  )
}
